import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchCurrentDateVPO } from "../../api/api";
import { fetchCurrentDateSuccessVPO, fetchCurrentDateFailureVPO } from "./date";

export function* handleFetchCurrentDateVPO(): SagaIterator {
  try {
    const data = yield call(fetchCurrentDateVPO);
    yield put(fetchCurrentDateSuccessVPO(data));
  } catch (error) {
    yield put(fetchCurrentDateFailureVPO(error.message));
  }
}
